import { customAxios } from './customAxios'

export function sendRichiestaSupporto(data) {
  const config = {
    headers: {
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }

  const body = { ...data, groupsId: ['FUNZIONE_AML'] }

  const sendRichiestaSupportoRequest = customAxios.post(
    `/${process.env.REACT_APP_PATH_NEW_PREFIX}/richiesta/supporto/send`,
    body,
    config,
  )
  return sendRichiestaSupportoRequest
}
